module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAAXVBMVEVHcEz9ch3/5qb93Jr9Ygf/YQj9lET/kD/9unD/xHz3ZhX8cBn6Zg//2pn956b97Kv94aD84aD915T8Zw78fSj8sGb8hzT9vnX8kUD8nE39y4X8chz95KP8qV38pFeRhQ5pAAAAEnRSTlMAhUOElUOJXYlcI/h3I5aWknflhtdtAAAAf0lEQVR42rXISQ7DIBAEwICBkD0G79v/n5nEtNSXmYul1LFOx1zvxutF51vO2anFbOb5214pZtfs7eRiDl1pJxZzHNBeKeQ2oo1ccGlXtFEK2bfoIBazRwelkNOEDnLBIyV0lIrqVBopFFRL6SgX2WXvqBW9fl3pRfb5tlL91wdDkBZnpPAJHQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fission/ExperienceGold/dian.png
// module id = O8Fk
// module chunks = 216